import { useAppLanguage } from "hooks/useAppLanguage";

const Footer = () => {
  const language = useAppLanguage();
  const isArabic = language === "ar";
  const year = new Date().getFullYear();

  return (
    <div className="flex w-full items-center justify-center px-4 pb-8 pt-3">
      <p className="text-center text-sm font-medium text-gray-500 dark:text-gray-400">
        {isArabic
          ? `© ${year} Easyfollow Platform. جميع حقوق الملكية محفوظة.`
          : `© ${year} Easyfollow Platform. All rights reserved.`}
      </p>
    </div>
  );
};

export default Footer;
